import React from 'react';
import FlowNodeIcon from '../../FlowNodeIcon';
import { useProjectState } from '@starflow/app/store';
import { isGtLen } from '../../../utils';
import { Tooltip } from '@mantine/core';
import { getProcessor } from '@starflow/app/helpers/flow';
import LinkIcon from '../assets/link.svg';
import cs from 'classnames';

const FlowLists = React.memo(({ data }) => {
  const currentNodeId = useProjectState('currentNodeId');
  const autoRunningFlowId = useProjectState('autoRunningFlowId');
  const nodeMap = useProjectState('nodeMap');
  const flows = useProjectState('flows');
  const list = data.nodeOrderList.map((id) => nodeMap[id]);
  const handleClick = (data) => {
    const processor = getProcessor(data.type);

    if (autoRunningFlowId === data.flowId) {
      return;
    }

    if (processor?.onNodeClick) {
      processor.onNodeClick(data);
    }
  };

  const linksList = (inputs) => {
    const kvMap = inputs.map((input) => ({
      value: input.label ?? '原图',
      label: nodeMap[input.sourceUnitId]?.data.label,
    }));
    return (
      <div className="ml-5">
        {kvMap.map(({ label, value }, idx) => {
          return (
            <div className="flex text-[#7A7A7A] scale-90" key={idx}>
              <span className="text-xs">{label}</span>
              <img className="w-[16px] h-[16px]" src={LinkIcon} alt="" />
              <span className="text-xs">{value}</span>
            </div>
          );
        })}
      </div>
    );
  };
  const currentAutoRuningNodeTitle = () => {
    return flows.find((flow) => flow.flowId === autoRunningFlowId)?.data?.title;
  };
  const text = currentAutoRuningNodeTitle();
  return (
    <div className="flex flex-col overflow-auto mb-10">
      {/* { ? <div className="px-1 pt-2">{currentAutoRuningNodeTitle()}</div> : null} */}
      {autoRunningFlowId ? (
        <div className="rounded mx-1 mt-2 px-2 bg-[#ECF5FF] text-[#009DFF] h-[26px] flex justify-between items-center">
          {isGtLen(text) ? (
            <Tooltip withArrow position="top" offset={10} className="scale-90" label={text}>
              <div className="overflow-ellipsis overflow-hidden whitespace-nowrap w-[100px] text-left">
                <span className="block flex-1 overflow-ellipsis overflow-hidden whitespace-nowrap">{text}</span>
              </div>
            </Tooltip>
          ) : (
            <span className="block flex-1 overflow-ellipsis overflow-hidden whitespace-nowrap">{text}</span>
          )}
          <span className="h-[16px] px-1 bg-[#009DFF] pt-[1px] flex flex-shrink-0 rounded-[1px]">
            <span className="scale-90 text-white text-xs">运行中</span>
          </span>
        </div>
      ) : null}
      <div className="p-3">
        <span className="text-[#7A7A7A] overflow-ellipsis overflow-hidden whitespace-nowrap">{data.data.title}</span>
        {list.map((item) => {
          const label = item.data.label;
          const inputs = item.data.inputs;
          return (
            <>
              <div
                className="flex h-[30px] items-center cursor-pointer bg-transparent"
                onClick={() => handleClick(item.data)}
              >
                <FlowNodeIcon type="unit" isSelected={currentNodeId === item.id} />
                {isGtLen(label) ? (
                  <Tooltip withArrow position="top" offset={10} className="scale-90" label={label}>
                    <div
                      className={cs(
                        'overflow-ellipsis overflow-hidden whitespace-nowrap w-[100px] text-left h-[18px] ml-[10px]',
                        currentNodeId === item.id ? 'text-[#009DFF]' : 'text-[#2D2D2D]',
                      )}
                    >
                      {label}
                    </div>
                  </Tooltip>
                ) : (
                  <span
                    className={cs(
                      'h-[18px] block ml-[10px]',
                      currentNodeId === item.id ? 'text-[#009DFF]' : 'text-[#2D2D2D]',
                    )}
                  >
                    {label}
                  </span>
                )}
              </div>
              {inputs?.length ? linksList(inputs) : null}
            </>
          );
        })}
      </div>
    </div>
  );
});

export default FlowLists;
